<template>
  <div class="ding-group">
    <!-- 选择钉钉群 -->
    <div class="content-item">
      <div class="item-title">
        通知群
        <span class="require-flag">*</span>
      </div>
      <div class="item-group">
        <NormalSelect
          size="normal"
          :select-list="groupMethods"
          :selectedItem.sync="inputData.selGroupMethods"
        ></NormalSelect>
        <div class="tip-btn tip-icon" @click="gotoSetting">
          <i class="el-icon-plus"></i>
        </div>
      </div>
    </div>
    <!-- 选择钉钉群 End -->

    <!-- 通知内容 -->
    <div class="content-item">
      <div class="item-title">
        通知内容
        <span class="require-flag">*</span>
      </div>
      <textarea-editor
        class="item-text"
        v-model="inputData.richTextObj"
        :var-group="workflowVarGroupString"
        min-height="160"
        max-height="400"
      ></textarea-editor>
    </div>
    <!-- 审批、通知、查找内容 End -->

    <!-- 选择 人员 -->
    <set-people
      ref="SetPeople"
      class="set-people"
      multiple
      name="选择@人员"
      :from="workFlowData.type == 'task' ? 'Project' : 'App'"
      :people-group="flowConnectedData | screenPeople"
      :flow-info="workFlowProcess"
      :project-id="workFlowData.appId"
      :app-id="workFlowData.appId"
      :isRequired="false"
    ></set-people>
    <!-- 选择 人员 -->
  </div>
</template>

<script>
import NormalSelect from "@/components/UIComponents/NormalSelect"
import Filters from "../../../mixin/filters"
import SetPeople from "./SetPeople/SetPeople"
import TextareaEditor from "@/components/UIComponents/TextareaEditor"
import { getDingGroupList } from "@/api/dingGroup"

export default {
  name: "ding-group",
  data() {
    return {
      groupMethods: [],
      selGroupMethods: "",
      richTextObj: {}
    }
  },
  props: {
    inputData: Object,
    flowConnectedData: Array,
    workflowVarGroupString: Array,
    workFlowData: Object,
    workFlowProcess: Object
  },
  mixins: [Filters],
  components: {
    NormalSelect,
    SetPeople,
    TextareaEditor
  },
  methods: {
    init() {
      getDingGroupList(this.workFlowData.appId).then(res => {
        this.groupMethods = res.map(v => {
          return {
            label: v.name,
            value: v.id
          }
        })
      })
      this.richTextObj = {
        text: this.workFlowProcess.data.content,
        arr: this.workFlowProcess.extra?.textarea
      }
      this.$nextTick(() => {
        this.$refs.SetPeople.init()
      })
    },
    output() {
      if (!this.inputData.selGroupMethods) return { result: false, msg: "未选择通知群！" }
      if (!this.inputData.richTextObj.arr || this.inputData.richTextObj.arr.length == 0)
        return { result: false, msg: "未填写通知内容！" }
      Object.assign(this.workFlowProcess.extra, {
        candidates: this.groupMethods.filter(v => v.value == this.inputData.selGroupMethods)[0]
          .label
      })
      return this.$refs.SetPeople.output()
    },
    gotoSetting() {
      if (this.workFlowData.type == "task") {
        const { href } = this.$router.resolve({
          name: "admin-project-robot",
          params: {
            projectId: this.workFlowData.appId
          }
        })
        window.open(href, "_blank")
      } else {
        const { href } = this.$router.resolve({
          name: "admin-app-robot",
          params: { appId: this.workFlowData.appId }
        })
        window.open(href, "_blank")
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ding-group {
  .content-item {
    font-size: 13px;
    &:not(:first-child) {
      .item-title {
        margin-top: 18px;
      }
    }
    .item-title {
      font-weight: bold;
      .itemSubTitle {
        margin-left: 5px;
        font-size: 12px;
        cursor: pointer;
        color: #bdbdbd;
        &:hover {
          color: #1e88e5;
        }
      }
    }
    .require-flag {
      color: red;
      font-size: 22px;
      position: relative;
      top: 3px;
    }
    .item-text {
      margin-top: 10px;
    }
    .itemSubTitle {
      margin-top: 10px;
      font-size: 13px;
    }
    .title-tip {
      margin-top: 10px;
      color: #9e9e9e;
    }
    .item-group {
      display: flex;
      align-items: center;
    }
  }
  .set-people {
    margin-top: 10px;
  }
  .tip-btn {
    cursor: pointer;
    width: 40px;
    min-width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    border-style: solid;
    border-color: #ddd;
    box-sizing: border-box;
    border-width: 1px 1px 1px 0;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    color: #9e9e9e;
  }
  ::v-deep {
    .normal-select .el-input .el-input__inner {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
  }
}
</style>
